import { buildQueryParams } from "../utils/buildQueryParams";
import { APIInstance } from "./api.config";

const { api } = new APIInstance({ path: "/v1/users/" });

export const AdminService = {
  getUserList: (filters) => {
    const params = buildQueryParams(filters);
    return api.get(`?${params.toString()}`);
  },

  getUserDetails: (userId) => {
    return api.get(`/${userId}`);
  },

  createUser: (userDetails) => {
    return api.post("", userDetails);
  },

  updateUser: (id, userDetails) => {
    return api.put(`/${id}`, userDetails);
  },

  deleteUser: (id) => {
    return api.delete(`/${id}`);
  },

  resetPassword: (userId, payload) => {
    return api.put(`${userId}/reset-password`, payload);
  },
};
